import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IEntitlementRepository } from '../../repositories/interfaces/iEntitlementRepository';
import { IPaymentSwitchGeneratePinRequest } from '../../../entity/interface/iEntitlements';
import { CSRFTokenRequest } from '../../../entity';
export interface IPaymentSwitchGeneratePinUseCase {
    execute(
        payload: IPaymentSwitchGeneratePinRequest,
        authToken: string,
        authSign: string,
        identityToken: string,
        csrfToken: CSRFTokenRequest
    ): Promise<any>;
}

export class PaymentSwitchGeneratePinUseCase implements IPaymentSwitchGeneratePinUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get paymentSwitchGeneratePinRepository(): IEntitlementRepository {
        return container.resolve<IEntitlementRepository>(DI.REPOSITORIES.IEntitlementRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        payload: IPaymentSwitchGeneratePinRequest,
        authToken: string,
        authSign: string,
        identityToken: string,
        csrfToken: CSRFTokenRequest
    ): Promise<any> {
        const response = await this.paymentSwitchGeneratePinRepository.paymentSwitchGeneratePin(
            payload,
            authToken,
            authSign,
            identityToken,
            csrfToken
        );
        return response.data.status.toLocaleLowerCase() === 'success' || false;
    }
}
